import React from 'react';
import { connect } from 'react-redux';

import {
    eventUniqueNameSelector,
    eventIdSelector,
    eventSelector,
} from '../../../../selectors/EventSelectors';
import { hasWhitelabelVenue } from '../../../../utils/RingEmbedScript';
import { mainEventColorSelector } from '../../../../selectors/SiteConfSelectors';
import useFullScreenContainer from '../hooks/useFullscreenContainer';
import useLoadingState from '../hooks/useLoadingState';
import useEmbedModule from '../hooks/useEmbedModule';
import LoaderView from '../../LoaderView';
import { SELECTORS } from '../constants';

const PeopleDirectoryContainer = ({
    eventId,
    eventUniqueName,
    mainEventColor,
    isWhitelabel,
}) => {
    const { containerRef } = useFullScreenContainer({
        headerSelector: SELECTORS.HEADER,
        footerSelector: SELECTORS.FOOTER
    });
    const { isLoading } = useLoadingState(isWhitelabel);
    useEmbedModule({
        moduleName: 'PeopleDirectory',
        eventId,
        eventUniqueName,
        containerRef,
        mainEventColor,
        isWhitelabel,
    });

    return (
        <div ref={containerRef} className="people-directory-container">
            {isLoading && (
                <div className="people-directory-loader">
                    <LoaderView />
                </div>
            )}
        </div>
    );
};

export default connect(state => ({
    eventId: eventIdSelector(state),
    eventUniqueName: eventUniqueNameSelector(state),
    mainEventColor: mainEventColorSelector(state),
    isWhitelabel: hasWhitelabelVenue(eventSelector(state)),
}))(PeopleDirectoryContainer);
